import React, { useCallback } from 'react';
import { toast } from 'react-toastify';

import { useUser } from '../../hooks/users';
import { useWebSocketMessageListener } from '../../websocket/hooks';

/**
 * Display the message when one received from WebSocket connection
 */
const MessageBannerTester: React.FC = () => {
  const user = useUser();
  const handleMessage = useCallback(
    message => {
      // only visible to admins
      if (message.message && user?.isAdmin) {
        toast(message.message);
      }
    },
    [user?.isAdmin]
  );
  useWebSocketMessageListener(handleMessage);
  return null;
};

export default MessageBannerTester;
